const inputCls = "w-full bg-transparent border-b border-[#1A1A1A]/15 py-3.5 text-base text-[#1A1A1A] placeholder:text-[#B5B5B0] focus:border-[#1A1A1A] outline-none transition-colors duration-300 rounded-none";
const labelCls = "block text-xs uppercase tracking-[0.18em] text-[#4A4A4A] font-medium mb-1";

function Label({ id, label, optional }) {
  return (
    <label htmlFor={id} className={labelCls}>
      {label} {optional && <span className="normal-case tracking-normal text-[#B5B5B0]">— optional</span>}
    </label>
  );
}

export function Field({ label, id, optional, ...props }) {
  return (
    <div>
      <Label id={id} label={label} optional={optional} />
      <input id={id} data-testid={id} className={inputCls} {...props} />
    </div>
  );
}

export function TextArea({ label, id, rows = 4, optional, ...props }) {
  return (
    <div>
      <Label id={id} label={label} optional={optional} />
      <textarea id={id} data-testid={id} rows={rows} className={`${inputCls} resize-none`} {...props} />
    </div>
  );
}

export function Select({ label, id, options, placeholder = "Select…", optional, ...props }) {
  return (
    <div>
      <Label id={id} label={label} optional={optional} />
      <select id={id} data-testid={id} className={`${inputCls} bg-[#F9F9F8]`} {...props}>
        <option value="">{placeholder}</option>
        {options.map((o) => <option key={o} value={o}>{o}</option>)}
      </select>
    </div>
  );
}

export function SubmitButton({ children, id, loading }) {
  return (
    <button type="submit" data-testid={id} disabled={loading}
      className="w-full sm:w-auto bg-[#1A1A1A] text-[#F9F9F8] text-[12px] uppercase tracking-[0.22em] px-10 py-4 rounded-full disabled:opacity-50 transition-colors duration-300 hover:bg-[#4A4A4A]">
      {loading ? "Sending…" : children}
    </button>
  );
}

export function ThankYou({ title = "Thank you!", text, testId }) {
  return (
    <div data-testid={testId} className="py-16 text-center max-w-md mx-auto">
      <p className="font-serif text-4xl mb-4">{title}</p>
      <p className="text-sm text-[#4A4A4A] leading-relaxed mb-10">{text}</p>
      <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
        <a href="/" data-testid={`${testId}-home-link`}
          className="text-[11px] uppercase tracking-[0.22em] border border-[#1A1A1A]/20 px-8 py-3.5 rounded-full hover:border-[#1A1A1A] transition-colors">
          Back to Home
        </a>
        <a href="/photography" data-testid={`${testId}-portfolio-link`}
          className="text-[11px] uppercase tracking-[0.22em] bg-[#1A1A1A] text-[#F9F9F8] px-8 py-3.5 rounded-full hover:bg-[#4A4A4A] transition-colors">
          Browse Portfolio
        </a>
      </div>
    </div>
  );
}
